import { useState, useMemo, useCallback } from 'react'
import { BrandContract } from 'models'

export const DEFAULT_BRAND = ''
export default function useBrandFilter(
    itemBrandNames: string[] = [],
    brands: BrandContract[] = [],
) {
    const [selectedBrand, setSelectedBrand] = useState<string[]>([])

    const brandOptions = useMemo(() => {
        let compBrands = brands
            .filter((a) => !itemBrandNames.includes(a.name || DEFAULT_BRAND))
            .map((a) => a.name || DEFAULT_BRAND)
        let options = [
            ...[...itemBrandNames, ...compBrands].map((k) => {
                if (k === DEFAULT_BRAND)
                    return { label: 'No Brand', value: DEFAULT_BRAND }
                return {
                    label: k || DEFAULT_BRAND,
                    value: k || DEFAULT_BRAND,
                }
            }),
        ]
        const a = options.sort((a, b) => {
            if (a.value === DEFAULT_BRAND) return -1
            if (b.value === DEFAULT_BRAND) return 1
            return a.value.localeCompare(b.value)
        })
        return [...a]
    }, [brands, itemBrandNames])

    const brandNumber = useMemo(() => {
        return itemBrandNames.filter((a) => a !== '').length + brands.length
    }, [brands.length, itemBrandNames])

    const handleClearFilter = useCallback(() => {
        setSelectedBrand([])
    }, [])

    return {
        brandNumber,
        handleClearFilter,
        brandOptions,
        selectedBrand,
        setSelectedBrand,
    }
}
